import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { EMPTY, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { HelperService } from 'src/app/services/helpers.service';
import { btnLoading, retryHttp } from '../core/Functions';
import { IAppUser } from '../interface/appUser.interface';
import { environment } from './../../environments/environment';
import { FirebaseService } from './firebase.service';
import { GeolocationService } from './geolocation.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  private _jwt = null;
  private _user: IAppUser = null;
  private _locais = null;
  private _dominio = null;
  private _base = null;
  public whatsVerify = null;
  public API_URL = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private firebaseService: FirebaseService,
    private alertController: AlertController,
    private geoS: GeolocationService,
    private helperS: HelperService
  ) {
    this.processApiUrl(localStorage.getItem('dominio'));
  }

  get user(): IAppUser | null {
    if (!this._user) {
      this._user = JSON.parse(localStorage.getItem('user'));
    }
    return this._user;
  }

  set user(user: IAppUser) {
    this._user = user;
    localStorage.setItem('user', JSON.stringify(user));
  }

  set jwt(jwt) {
    this._jwt = jwt;
    localStorage.setItem('jwt', JSON.stringify(jwt));
  }

  get jwt() {
    if (!this._jwt) {
      this._jwt = JSON.parse(localStorage.getItem('jwt'));
    }
    return this._jwt;
  }

  set locais(locais) {
    this._locais = locais;
    localStorage.setItem('locais', JSON.stringify(locais));
  }

  get locais() {
    if (!this._locais) {
      this._locais = JSON.parse(localStorage.getItem('locais'));
    }
    return this._locais;
  }

  get dominio() {
    if (!this._dominio) {
      this._dominio = localStorage.getItem('dominio');
    }

    // API_URL
    this.processApiUrl(this._dominio);

    return this._dominio;
  }

  set dominio(dominio) {
    this._dominio = dominio;

    // API_URL
    this.processApiUrl(this._dominio);

    localStorage.setItem('dominio', dominio);
  }

  get base() {
    if (!this._base) {
      this._base = localStorage.getItem('base');
    }

    return this._base;
  }

  set base(base) {
    this._base = base;

    localStorage.setItem('base', base);
  }

  processApiUrl(dominio) {
    this.API_URL = 'https://' + dominio + '.api.alleshub.com.br/api_allescorp/';
    if (!environment.production) {
      this.API_URL = 'http://localhost/erp/esal_erp_api/public/api_allescorp/';
    }
  }

  login(frm, $event) {
    return this.http.post(this.API_URL + 'userApp/login', frm).pipe(
      btnLoading($event),
      tap((res: any) => {
        this.user = res.userApp;
        this.jwt = res.jwt;
        this.locais = res.locais;
      })
    );
  }

  logout() {
    this.user = null;
    this.router.navigateByUrl('/login');
    this.firebaseService.signOut();
    // this.geoS.clearWatch();
  }

  async presentAlertConfirmLogout() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Logout',
      message: 'Deseja sair do sistema?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {},
        },
        {
          text: 'Ok',
          handler: () => {
            this.logout();
          },
        },
      ],
    });

    await alert.present();
  }

  register(frm, $event) {
    return this.http.post(this.API_URL + 'userApp/create', frm).pipe(
      retryHttp(4, 4),
      btnLoading($event),
      catchError((error) => {
        if (
          error.message ===
          'Esse CPF já está cadastrado na base de dados. Em caso de dúvidas, entre em contato com nossa equipe'
        ) {
          this.helperS.dismissLoader();
        }
        else if (
          error.message === '{"user":["O campo user já está sendo utilizado."]}'
        ) {
       //  console.log('caiu erro')
          this.helperS.dismissLoader();
        }
        else {
    //      console.log('caiu else');
          this.helperS.dismissLoader();
          this.helperS.toast(
            'Não foi possível fazer o registro, verifique sua internet e tente novamente.',
            'warning'
          );
        }

        return EMPTY;
      })
    );
  }
  sendCode(to): Observable<any> {
    const sms = this.helperS.makeRandom();
    const body = 'Seu codigo de validação é:' + sms;
    this.whatsVerify = sms;
    const url = this.API_URL + 'notification/sendMessage';
    const payload = { to, body };
    return this.http.post(url, payload);
  }
}
